/**
 *
 * @class RouteRequirements
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.8] app/src/model/RouteRequirements.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */
export const MIN_VISIT= 1;
export const MAX_VISIT = 7;

export const visits = [1,2,3,4,5,6,7];

export default class RouteRequirements {
  constructor(modelData) {
    /** @type array|null Visits for which route is allowed, note that this uses target version, so this is about when a visit becomes available, it doesn't necessarily needs to be started yet. */
    this._allowedVisits = null;
    /** @type boolean */
    this._requireLogin = true;
    /** @type boolean */
    this._requiresPatient = true;
    /** @type array|null */
    this._enabledModules = null;
    /** @type array<function> */
    this._customChecks = [];
  }

  /**
   * @param allowedVisits array|null
   * allowed visits is based on the target visit/version, example when visit 3 is allowed, the route will become
   * available after visit 2 has been closed but before visit 3 has already been opened.
   */
  setAllowedVisits(allowedVisits) {
    this._allowedVisits = allowedVisits;
    return this;
  }

  getEnabledModules() {
    return this._enabledModules;
  }

  getCustomChecks() {
    return this._customChecks;
  }

  addCustomCheck(customCheckFunction) {
    this._customChecks.push(customCheckFunction);
    return this;
  }

  setEnabledModules(enabledModules) {
    if (typeof enabledModules === 'string') {
      enabledModules = [enabledModules];
    }
    this._enabledModules = enabledModules;
    return this;
  }

  setMinimumAllowedVisit(allowedVisit) {
    let v = this._allowedVisits === null ? visits : this._allowedVisits;
    this._allowedVisits = v.filter(visit => visit >= allowedVisit);
    return this;
  }

  setMaxAllowedVisit(allowedVisit) {
    let v = this._allowedVisits === null ? visits : this._allowedVisits;
    this._allowedVisits = v.filter(visit => visit <= allowedVisit);
    return this;
  }

  getAllowedVisits() {
    return this._allowedVisits;
  }

  isRequireLogin() {
    return this._requireLogin;
  }

  setRequiresPatient(requiresPatient) {
    this._requiresPatient = requiresPatient;
    return this;
  }

  getRequiresPatient() {
    return this._requiresPatient || this.getAllowedVisits() !== null;
  }

  setRequireLogin(value) {
    this._requireLogin = value;
    return this;
  }
}
